<template>
  <!-- 消息提示弹窗 -->
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      width="21%">
    <img src="@/assets/find-job/success-icon.png" class="success" alt="">
      <slot></slot>
      <div class="g-flex g-row-center g-m-t-30">
        <div class="cancel-btn g-flex g-row-center" v-if="showCancel" @click="doCancel">{{cancelText}}</div>
        <div class="submit-btn g-flex g-row-center" v-if="showConfirm" @click="doSubmit">{{confirmText}}</div>
      </div>
  </el-dialog>
</template>

<script>
export default {
  name: "popup-message-box",
  props:{
    // 是否显示取消按钮
    showCancel:{
      type:Boolean,
      default: true
    },
    // 确认按钮的文字
    confirmText:{
      type:String,
      default:'确定'
    },
    // 确认按钮的文字
    cancelText:{
      type:String,
      default:'取消'
    },
    // 是否显示确认按钮
    showConfirm:{
      type:Boolean,
      default: true
    }
  },
  data(){
    return{
      dialogVisible:false,
    }
  },
  methods:{
    // 开启
    open(){
      this.dialogVisible = true
    },
    // 关闭
    close(){
      this.dialogVisible = false
    },
    // 取消事件
    doCancel(){
      this.$emit('cancel')
      this.close()
    },
    // submit事件
    doSubmit(){
      this.$emit('submit')
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
  .success{
    position: absolute;
    top: -60px;
    width: 120px;
    height: 120px;
    left: 35%;
  }

  .cancel-btn{
    padding: 6px 30px;
  }

  .submit-btn{
    padding: 6px 30px;
  }
</style>